<template>
	<footer :class="isDark ? 'dark' : null">
		<div class="footer">
			<div class="footer__left">
				<h3>Join TheJOIN</h3>
				<h4>In the new mobile space with you</h4>
			</div>
			<div class="footer__right">
				<div class="footer__right__adress">
					<b>대표</b>
					<p>이명호</p>
					<b>주소</b>
					<p>
						서울시 강남구 봉은사로30길 63,
						3층(역삼동, 영신빌딩)
					</p>
					<b>대표전화</b>
					<p>+82-2-6949-0335</p>
					<b>E-Mail</b>
					<p>thejoin@thejoin.co.kr</p>
				</div>
				<div class="footer__right__terms">
					<button
						@click="$router.push('/policy')"
					>
						<b>개인정보처리방침</b>
					</button>
					<button @click="$router.push('/terms')">
						<b>이용약관</b></button
					><br class="mbr" />
					<b>사업자등록번호</b>
					<span class="tel">451-86-00750</span>
				</div>
				<p class="footer__right__copyright">
					Copyright© THEJOIN. All Rights Reserved
				</p>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	props: {
		isDark: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	setup() {
		function navigateToPage(pageUrl) {
			window.location.href = pageUrl;
		}
		return { navigateToPage };
	},
};
</script>

<style lang="scss" scoped>
footer {
	background: white;
	width: 100%;
	display: flex;
	justify-content: center;
	border-top: 1px solid $gray2;
	padding-bottom: 60px;
	.footer {
		height: 100%;
		width: calc($tabletW + 1px);
		margin: 0 auto;
		display: flex;
		align-items: stretch;
		justify-content: space-between;
		&__left {
			width: 50%;
			& > h3 {
				margin-top: 56px;
				@include D4($gray5);
			}
			& > h4 {
				@include BodyLB($gray4);
			}
		}
		&__right {
			margin-top: 56px;
			@include BodyS($gray5);
			width: 50%;
			&__adress {
				display: flex;
				flex-wrap: wrap;
				& > b {
					width: 72px;
					font-weight: 500;
				}
				& > p {
					width: calc(100% - 72px);
				}
			}
			&__terms {
				@include BodyS($gray5);
				b {
					font-weight: 500;
				}
				margin-top: 30px;
				& > button {
					@include BodyS($gray5);
					padding-right: 12px;
					margin-right: 12px;
					border-right: 1px solid $gray3;
				}
				.tel {
					margin-left: 12px;
				}
			}
			&__copyright {
				margin-top: 8px;
			}
		}
	}
	&.dark {
		background: $bgD;
		border-color: $gray6;
		.footer {
			&__left {
				& > h3 {
					color: $gray0;
				}
			}
			&__right {
				&__terms {
					& > button {
						border-color: $gray6;
					}
				}
			}
		}
	}
}

// 태블릿
@media screen and (max-width: $tabletW) {
	footer {
		.footer {
			width: 100%;
			padding: 0 24px;
			flex-direction: column;
			justify-content: start;
			&__left {
				width: 100%;
				& > h3 {
					margin-top: 30px;
					@include T4($gray5);
				}
				& > h4 {
					@include BodyMB($gray4);
				}
			}
			&__right {
				margin-top: 40px;
				width: 100%;
				&__terms {
					margin-top: 30px;
					& > button {
						@include BodyS($gray5);
						padding-right: 12px;
						margin-right: 12px;
						border-right: 1px solid $gray3;
					}
					.tel {
						margin-left: 12px;
					}
				}
				&__copyright {
					margin-top: 8px;
				}
			}
		}
	}
}

// 모바일
@media screen and (max-width: $mobileW) {
	footer {
		padding-bottom: 50px;
		.footer {
			&__left {
				& > h3 {
					@include M4($gray5);
				}
			}
		}
	}
}
</style>
